module.exports = __webpack_public_path__ + "9332b7f8062b5054f3cfa4c7c3349127.svg";